import Caption from 'components/Luxkit/Typography/Caption'
import useInterval from 'hooks/useInterval'
import { DateDifference, dateDifference } from 'lib/datetime/dateUtils'
import React, { useState } from 'react'

interface Props {
  deal: App.FlightDeal;
}

function FlightDealContentCountdown(props: Props) {
  const { deal } = props
  // stores the time in seconds
  const [timeRemaining, setTime] = useState<DateDifference>(dateDifference(new Date(deal.salesEndDate)))

  useInterval(() => {
    setTime(dateDifference(new Date(deal.salesEndDate)))
  }, 1000, { disabled: new Date() > new Date(deal.salesEndDate) })

  if (timeRemaining.days < 1) {
    return <Caption variant="small" as="span">
      {Math.max(timeRemaining.hours, 0)}H : {Math.max(timeRemaining.minutes, 0)}M : {Math.max(timeRemaining.seconds, 0)}S
    </Caption>
  }

  return <Caption variant="small" as="span">{timeRemaining.days} days</Caption>
}

export default React.memo(FlightDealContentCountdown)
